import { createAuthStore } from '@/core/store';
import { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from 'axios';

export const requestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
   const store = createAuthStore();
   if (!(config.headers instanceof AxiosHeaders)) {
      config.headers = new AxiosHeaders(config.headers);
   }
   // setting token
   config.headers.set('Authorization', `Bearer ${store.getState().accessToken}`);

   return config;
};

export const requestErrorInterceptor = (error: AxiosError) => {
   return Promise.reject(error);
};
